import { createDeferred } from 'shared/utils/deferred';

const servicesReady = createDeferred();

/** Resolves once the services started: the stored data is repaired and every service listens. */
export function whenServicesReady(): Promise<void> {
  return servicesReady.promise;
}

/** Called once by `initAllServices`, after the last service started. */
export function markServicesReady(): void {
  servicesReady.resolve();
}
